import { render, staticRenderFns } from "./M205.vue?vue&type=template&id=06aed888&scoped=true"
import script from "./M205.vue?vue&type=script&lang=js"
export * from "./M205.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Cy.css?vue&type=style&index=0&id=06aed888&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aed888",
  null
  
)

export default component.exports